
<template>
  <div>
    <div v-if="favoriteVenues">
      <h3><slot name="favorite-title"></slot></h3>
      <div class="check-button-container">
        <check-button
          v-for="house in favoriteVenues"
          v-model="selectedVenues"
          :color="localColour"
          :disabled="disableLocal && isLocalHouse(house)"
          :icon="house.icons.darkSvg"
          :key="house.id"
          :value="house.id"
          :name="house.name"
        >
          {{ house.name }}
        </check-button>
      </div>
    </div>

    <h3 v-if="$slots['all-title']"><slot name="all-title"></slot></h3>
    <div class="check-button-container">
      <location-accordion
        v-model="selectedVenues"
        :availableVenueIds="availableVenueIds"
        :houses="houses"
        :citiesWithoutHouses="citiesWithoutHouses"
        :localHouse="localHouse"
        :radio="radio"
        :disableLocal="disableLocal"
      />
    </div>
  </div>
</template>

<script>
import designTokens from '@sohohouse/design-system/dist/tokens/tokens.json'
import CheckButton from '~/components/check-button'
import LocationAccordion from '~/components/location-accordion'

export default {
  components: {
    LocationAccordion,
    CheckButton
  },

  data () {
    return {
      localColour: designTokens.color_black
    }
  },

  props: {
    favoriteVenues: {
      type: Array,
      required: false
    },
    availableVenueIds: {
      type: Array
    },
    houses: {
      type: Array,
      required: true
    },
    citiesWithoutHouses: {
      type: Array,
      required: false,
      default: () => []
    },
    localHouse: {
      type: Object,
      required: false
    },
    value: {
      type: [Array, String],
      default: null
    },
    radio: {
      type: Boolean,
      default: false
    },
    disableLocal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    selectedVenues: {
      get () {
        return this.value
      },

      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  methods: {
    isLocalHouse (house) {
      return this.localHouse && this.localHouse.id === house.id
    }
  }
}
</script>

<style lang="scss" scoped>


h3 {
  @include font('040');
  @include deprecated-f-color-dark;
  text-transform: none;
  font-weight: normal;
  margin-top: $d-med;

  &:first-child {
    margin-top: 0;
  }
}

.check-button-container {
  margin-top: $d-x-small;
}
</style>
